'use strict'
import $ from "jquery";
import IConstants from "@/common/constants/IConstants.js";

var self = new Object();

self.cssNestedConfirmModal = function() {
    let modalConfirm = $("#modalConfirm");
    modalConfirm
        .on('show.bs.modal', () => {
            let screen = modalConfirm.attr("for-screen");
            if(this.checkNestedModal(screen) === true) {
                $("#modalConfirm").css("z-index", "1051").css("padding-right", "0");
                $(".modal-backdrop:first").attr(screen, true).css("z-index", "1050");
            }
        })
        .on('hidden.bs.modal', () => {
            let screen = modalConfirm.attr("for-screen");
            if(this.checkNestedModal(screen) === true) {
                $('body').addClass("modal-open");
                const modal = $(".modal-backdrop[" + screen + "='true']");
                if (modal.length) {
                    modal.css("z-index", "");
                }
            }
        });
}

self.checkNestedModal = function(screen) {
    return IConstants.E_CONFIRM_SCREEN.DEPOSIT_VERITRANS === screen
        || IConstants.E_CONFIRM_SCREEN.WITHDRAWAL_BANK === screen
        || IConstants.E_CONFIRM_SCREEN.WITHDRAWAL_BRANCH === screen;
}

export default self;